<h5 class="ui-card-item-label" [title]="label">{{ label }}</h5>
<div class="ui-card-item-text" [title]="title ? title : ''">
  <div class="ui-card-item-text--truncated">
    <ng-content></ng-content>
  </div>
</div>
